import { makeStyles } from "..";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px 16px",
    [theme.breakpoints.up("md")]: {
      padding: 0,
    },
  },
  wrap: {
    display: "flex",
  },
  back: {
    alignSelf: "center",
    paddingRight: 16,
    height: 24,
  },
  content: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    minWidth: 1,
    [theme.breakpoints.up("md")]: {
      paddingRight: 4,
    },
  },
  refresh: {
    paddingTop: 2,
    paddingLeft: 12,
    [theme.breakpoints.up("md")]: {
      paddingTop: 8,
    },
  },
  more: {
    paddingTop: 2,
    paddingLeft: 12,
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  actions: {
    display: "flex",
    gap: 12,
    paddingTop: 2,
    paddingLeft: 16,
    [theme.breakpoints.up("md")]: {
      paddingTop: 0,
      paddingLeft: 20,
    },
    "&:empty": {
      paddingLeft: 0,
      [theme.breakpoints.up("md")]: {
        paddingLeft: 0,
      },
    },
  },
  extra: {
    marginTop: 20,
    [theme.breakpoints.up("md")]: {
      marginTop: 24,
    },
  },
}));
